import { DESKTOP_BREAKPOINT } from "@/constants/breakpoint";

const AICOPY_RESERVED_TOP_SEGMENTS = new Set(["agents", "my-orders"]);

/** @returns {{ pathname: string, search: string, hash: string }} */
export function parseUrlPathParts(pathOrUrl) {
  const raw = (pathOrUrl || "").trim();
  if (!raw) return { pathname: "", search: "", hash: "" };
  if (/^https?:\/\//i.test(raw)) {
    try {
      const u = new URL(raw);
      return { pathname: u.pathname, search: u.search, hash: u.hash };
    } catch {
      return { pathname: raw, search: "", hash: "" };
    }
  }
  const hashIdx = raw.indexOf("#");
  const hash = hashIdx >= 0 ? raw.slice(hashIdx) : "";
  const beforeHash = hashIdx >= 0 ? raw.slice(0, hashIdx) : raw;
  const qIdx = beforeHash.indexOf("?");
  const search = qIdx >= 0 ? beforeHash.slice(qIdx) : "";
  const pathname = qIdx >= 0 ? beforeHash.slice(0, qIdx) : beforeHash;
  return { pathname, search, hash };
}

/** 移动详情 `/aicopy/[strategyId]` 中的 strategyId；非详情路径返回 null */
export function getAicopyMobileDetailStrategyId(pathname) {
  const match = String(pathname || "").match(/^\/aicopy\/([^/]+)$/i);
  if (!match) return null;
  const segment = decodeURIComponent(match[1]).trim();
  if (!segment || AICOPY_RESERVED_TOP_SEGMENTS.has(segment.toLowerCase())) return null;
  return segment;
}

export function isAicopyMobileDetailPath(pathOrUrl) {
  const { pathname } = parseUrlPathParts(pathOrUrl);
  return Boolean(getAicopyMobileDetailStrategyId(pathname));
}

/** `/aicopy/15?x=1` → `/aicopy/agents/15?x=1`；已是 PC 路径或非详情则原样返回 */
export function mapAicopyMobileDetailPathToPc(pathOrUrl) {
  const { pathname, search, hash } = parseUrlPathParts(pathOrUrl);
  const strategyId = getAicopyMobileDetailStrategyId(pathname);
  if (!strategyId) return (pathOrUrl || "").trim();
  return `/aicopy/agents/${encodeURIComponent(strategyId)}${search}${hash}`;
}

export function isClientDesktopViewport() {
  if (typeof window === "undefined") return false;
  return window.innerWidth > DESKTOP_BREAKPOINT;
}

/**
 * 券跳转等：PC 端将移动详情链改写为 `/aicopy/agents/[id]`（保留 query/hash）。
 * @param {string} pathOrUrl
 * @param {{ preferDesktop?: boolean }} [options]
 */
export function resolveAicopyDetailPathForViewport(pathOrUrl, { preferDesktop } = {}) {
  const trimmed = (pathOrUrl || "").trim();
  if (!trimmed) return trimmed;
  const useDesktop = preferDesktop ?? isClientDesktopViewport();
  if (!useDesktop) return trimmed;

  const isAbs = /^https?:\/\//i.test(trimmed);
  const parts = parseUrlPathParts(trimmed);
  const mapped = mapAicopyMobileDetailPathToPc(`${parts.pathname}${parts.search}${parts.hash}`);
  if (mapped === `${parts.pathname}${parts.search}${parts.hash}`) return trimmed;

  if (!isAbs) return mapped;

  try {
    const u = new URL(trimmed);
    const mappedParts = parseUrlPathParts(mapped);
    u.pathname = mappedParts.pathname;
    u.search = mappedParts.search;
    u.hash = mappedParts.hash;
    return u.toString();
  } catch {
    return mapped;
  }
}
